export class Tivo {
    constructor(socket, log) {
        this.socket = socket;
        this.asyncHandlers = [
            {
                name: 'keyboard',
                regExp: /KEYBOARD (.+)/i,
                callback: (match) => {
                    if (match[1].toLowerCase() === 'livetv') {
                        this.socket.send(`CH_STATUS 0016 0006 LOCAL`);
                    }
                    // no response
                },
            },
            {
                name: 'teleport',
                regExp: /TELEPORT (.+)/i,
                callback: (match) => {
                    this.socket.send('LIVETV_READY');
                },
            },
            {
                name: 'invalid',
                regExp: /.+/i,
                callback: (match) => {
                    this.socket.send('INVALID_COMMAND');
                },
            },
        ];
    }
}
Tivo.emulatorType = 'socketEmulator';
Tivo.key = '-NPZG9Lr3DO8F9BtdDDB';
